import loadCmiProducts from "@iewcasia/Store/Handlers/ProductDetails/LoadCmiProducts";
import { addToChainAfter, executeAwaitableHandlerChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getProductByPath } from "@insite/client-framework/Services/ProductServiceV2";
import { recentlyViewedGetProductCollectionParameter } from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import loadProductByPath from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import {
    chain,
    LoadProductIfNeeded,
    PrepareProduct,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";

const handleCmiRequest = ({ productId, props, properties }: any) => {
    if (properties) {
        const cmiProductsCount = +(properties["cmiProductsCount"] ?? 0);
        if (cmiProductsCount > 0) {
            props.dispatch(
                loadCmiProducts({
                    carouselId: "cmiProducts",
                    relatedProductType: "CMIRelatedProducts",
                    productId,
                }),
            );
        }
    }
};

replaceInChain(chain, LoadProductIfNeeded, async props => {
    /* Verndale Custom Feature - Keep same OOTB chain request */
    // if variantTypeId is not null this has variantTraits, and we need those loaded fully for this handler chain to work correctly
    // if product is discontinued then it may have replacement product, and we wait for it to be loaded
    if (!props.product || props.product.variantTypeId || props.product.isDiscontinued) {
        props.product = await executeAwaitableHandlerChain(
            loadProductByPath,
            { ...props.parameter, addToRecentlyViewed: true },
            props,
        );
    } else if (
        !props.product.detail ||
        !props.product.content ||
        !props.product.images ||
        !props.product.documents ||
        !props.product.specifications ||
        !props.product.attributeTypes ||
        !props.product.variantTraits
    ) {
        // we don't want to wait for this if we already partially have the product, because then we can't show the partially loaded product page
        props.dispatch(
            loadProductByPath({
                ...props.parameter,
                addToRecentlyViewed: true,
                onComplete: productProps => {
                    const configuration = productProps?.apiResult?.detail?.configuration;
                    if (configuration) {
                        props.dispatch({
                            type: "Pages/ProductDetails/InitConfigurationSelection",
                            configuration,
                        });
                    }

                    props.dispatch({
                        type: "Data/Products/ReplaceDataView",
                        parameter: recentlyViewedGetProductCollectionParameter,
                        dataView: {},
                    });

                    handleCmiRequest({
                        productId: productProps?.apiResult?.id,
                        props,
                        properties: productProps?.apiResult?.properties,
                    });
                },
            }),
        );
    } else {
        /* Verndale Custom Feature - Add properties expand to current request */
        getProductByPath({ ...props.parameter, addToRecentlyViewed: true, expand: ["attributes", "properties"] }).then(
            result => {
                props.dispatch({
                    type: "Data/Products/CompleteLoadProduct",
                    model: result,
                });

                handleCmiRequest({
                    productId: result.id,
                    props,
                    properties: result.properties,
                });
            },
        );
    }
});

addToChainAfter(chain, PrepareProduct, props => {
    handleCmiRequest({
        productId: props.product?.id,
        props,
        properties: props.product?.properties,
    });
});
